'use client'
import Image from 'next/image'
import { SvgChevronRight } from '@/components/icons'
import { ArrowSmallRightIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'

const FeaturesHero = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 sm:pt-[120px]">
      <div className="flex flex-col lg:flex-row gap-16">
        <div className="flex flex-col gap-6 w-full lg:max-w-[517px] justify-center">
          <div className="w-fit mx-auto lg:mx-0 h-8 pl-1 pr-2.5 py-1 bg-white bg-opacity-30 rounded-2xl border border-white justify-start items-center gap-3 inline-flex">
            <div className="px-2.5 py-0.5 bg-v8-blue rounded-2xl justify-start items-center flex">
              <p className="text-center text-white text-xs sm:text-sm font-medium leading-tight">
                Empowering Learning Journeys
              </p>
            </div>
            <div className="justify-start items-center gap-1 flex">
              <p className="text-v8-blue text-xs sm:text-sm font-medium leading-tight">
                Teach on Visely
              </p>
              <ArrowSmallRightIcon className="w-4 h-4 relative text-v8-blue" />
            </div>
          </div>
          <p className="text-v8-ink text-center lg:text-left text-5xl md:text-6xl font-bold md:leading-[72px]">
            Elevate Education with AI-Powered Innovation
          </p>
          <p className="text-v8-mut text-center lg:text-left text-lg md:text-xl font-normal leading-[30px]">
            Embark on a personalized learning adventure, where AI technology
            empowers students, nurtures growth, and fosters brilliance in every
            pursuit.
          </p>
          <Link
            href={'/login'}
            className="w-fit sm:mt-6 flex text-lg items-center gap-3 cursor-pointer font-semibold py-[15px] lg:mx-0 mx-auto text-center border-1 px-[29px] orange-500 rounded-lg shadow border border-orange-500 bg-orange-500 justify-center text-white"
          >
            Get Started
            <SvgChevronRight />
          </Link>
        </div>

        <div className="relative w-full h-96 sm:h-[640px]">
          <Image
            src={'/images/features-hero-2.webp'}
            alt="Hero"
            // width={720}
            // height={640}
            className="object-cover rounded-2xl"
            fill
            priority
          />
        </div>
      </div>
    </div>
  )
}

export default FeaturesHero
